import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'

let data = {
  phone: null,
  callget: false,
  feedbackText: null,
  feedbackTopic: null
}

export default class RequestsDataSource extends DataSourceBase {
  constructor(Vue, id) {
    super(Vue, id, data)
  }

  callAction(actionName, params) {
    if (actionName == 'saveRequest') {
      this.saveRequest()
      return
    }
    console.log(actionName, params)
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {
    this.$store.commit('SET_PROCESSING', true)
    GraphqQlApi.callOperation({ operationId: 'requests' }).then(response => {
      this.$store.commit('SET_PROCESSING', false)
      var requests = response.data.energyAccountQuery.feedback

      this.$store.commit(`${this.getStoreModuleName()}/setData`, {
        columns: requests.columns,
        rows: requests.data,
        childColumns: requests.childColumns,
        topics: requests.feedbackTopicEnumGq,
        phone: requests.phone,
      })
    })
  }
  saveRequest() {
    let currentData = this.getData()
    let text = currentData.feedbackText
    let topic = currentData.feedbackTopic
    let phone = currentData.phone
    let callget = currentData.callget
    this.$store.commit('SET_PROCESSING', true)
    GraphqQlApi.callOperation({ operationId: 'requestsMutation' }, { text, topic, phone, callget }).then(() => {
      currentData.feedbackText = ''
      this.$store.commit(`${this.getStoreModuleName()}/setData`, { ...currentData })
      this.refresh()
    })
  }
}